import Vue from 'vue';
import querystring from 'querystring';
import * as Publicaciones from '@lib/MercadoLibre/Publicaciones';
import * as Articulos from '@lib/Articulos';
import { Publicacion } from '@lib/MercadoLibre/Publicaciones';
import { Watch } from 'vue-property-decorator';
import { Paginacion, Wait } from '@/__env/ext';
import { Utiles } from '@env/pluggins/event-bus';
import { SignalDispatcher } from 'strongly-typed-events';
import { VistaBase, FiltrosBase } from '@/components/a-interfaz/a-controlador';
import router from '@/__env/router.index';
import { type } from 'os';
import { PresetImportarExcel } from '@/__env/lib/Ventas/ImportarExcel/Presets/Preset.nav';
import { Pedido } from '@/__env/lib/Ventas/Pedidos';
import * as Envios from '@/__env/lib/Ventas/Envios';
import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
import { match } from 'assert';
import { Articulo } from '@lib/Articulos';

type IPreset = {
    Columna: number;
    Tipo: number;
};
type ITipo = {
    Opcion?: 'titulo' | 'opcion';
    Id?: string;
    Nombre: string;
    Tipo?: 'number' | 'text';
    Ayuda?: string;
    MensajeError?: string;
    Validar?( x: string ): Promise<boolean>;
    Generico?: boolean;
};

export class ControladorSeccion
{

    public Preset: Record<number, string> = {};

    public RecargarPreset()
    {
        this._onRecargarPreset.dispatch();
    }

    private _onRecargarPreset = new SignalDispatcher();
    public get onRecargarPreset() { return this._onRecargarPreset.asEvent(); }

    async UsarPreset( preset: PresetImportarExcel )
    {

        this.Preset = {};
        this._onRecargarPreset.dispatch();
        await Wait( 50 );
        for ( let pre of preset.Columnas )
        {
            this.Preset[pre.Columna] = pre.Tipo;
        }
        this._onRecargarPreset.dispatch();
    }

    async LimpiarPreset()
    {
        this.Preset = {};
        await Wait( 50 );
        this._onRecargarPreset.dispatch();
    }

    AgregarAlPreset( col: number, tipo: number )
    {
        if ( this.Tipos[tipo] )
        {
            if ( !this.Tipos[tipo].Generico )
            {
                this.Preset[col] = this.Tipos[tipo].Id;
            } else
            {
                delete this.Preset[col];
            }

        }

    }
    public Tipos: ITipo[] = [

        //{ Id: 'no-especificado', Nombre: 'No especificado', Tipo: 'text', Generico: true},
        { Id: 'ignorar', Nombre: 'Ignorar', Tipo: 'text', Generico: true, Ayuda: 'Se omitirá procesar esta columna' },

        { Opcion: 'titulo', Nombre: 'Cliente' },
        { Id: 'cliente-id', Nombre: 'Codigo del cliente', Tipo: 'text', Ayuda: 'Código numerico del cliente. (El cliente debe existir en nuestra base de datos)' },
        { Id: 'cliente-nombre', Nombre: 'Nombre del cliente', Tipo: 'text', Ayuda: 'Para celdas con solo el nombre el cliente' },
        { Id: 'cliente-apellido', Nombre: 'Apellido del cliente', Tipo: 'text', Ayuda: 'Para celdas con solo el apellido el cliente' },
        //{ Id: 'cliente-completo', Nombre: 'Nombre y apellido del cliente', Tipo: 'text', Ayuda: 'Para celdas con el nombre completo el cliente. Ej. Carlos Perez' },
        {
            Id: 'cliente-documento', Nombre: 'Documento del cliente', Tipo: 'text',
            Validar: async ( x: string ) =>
            {
                return x.length == 0 || x.borraLetras().length > 6;
            },
            MensajeError: 'Alguna de estas celdas no contienen un DNI válido'
        },
        {
            Id: 'cliente-cuit', Nombre: 'CUIT del cliente', Tipo: 'text', Ayuda: 'Con o sin guiones. Lo detectaremos automaticamente',
            Validar: async ( x: string ) =>
            {
                return x.length == 0 || x.borraLetras().length == 11;
            },
            MensajeError: 'Alguna de estas celdas no contienen un CUIT válido'
        },

        { Id: 'cliente-telefono', Nombre: 'Teléfono del cliente', Tipo: 'text' },
        { Id: 'cliente-celular', Nombre: 'Célular del cliente', Tipo: 'text' },
        { Id: 'cliente-email', Nombre: 'Email del cliente', Tipo: 'text' },

        { Opcion: 'titulo', Nombre: 'Dirección fiscal (para la factura)' },
        { Id: 'cliente-direcion-calle', Nombre: 'Dirección fiscal - Calle', Tipo: 'text' },
        { Id: 'cliente-direcion-numero', Nombre: 'Dirección fiscal - Número', Tipo: 'text' },
        { Id: 'cliente-direcion-piso', Nombre: 'Dirección fiscal - Piso', Tipo: 'text' },
        { Id: 'cliente-direcion-departamento', Nombre: 'Dirección fiscal - Departamento', Tipo: 'text' },
        //{ Id: 'cliente-direcion-calle-completa', Nombre: 'Dirección fiscal - Calle y numero', Tipo: 'text' },
        { Id: 'cliente-direcion-localidad', Nombre: 'Dirección fiscal - Localidad', Tipo: 'text' },
        { Id: 'cliente-direcion-provincia', Nombre: 'Dirección fiscal - Provincia', Tipo: 'text' },
        { Id: 'cliente-direcion-codigo-postal', Nombre: 'Dirección fiscal - Codigo Postal', Tipo: 'text' },

        { Opcion: 'titulo', Nombre: 'Envío' },
        { Id: 'envio-importe-comision', Nombre: 'Comisión logistica', Tipo: 'number', Ayuda: 'Importe de comision logistica.' },
        { Id: 'envio-importe-propio', Nombre: 'Importe del envío (se agrega a la factura)', Tipo: 'number', Ayuda: 'Este importe se sumará aparte a la factura.' },
        { Id: 'envio-importe-cliente', Nombre: 'Importe del envío (no se agrega a la factura)', Tipo: 'number', Ayuda: 'Este importe no se sumará en la factura y no modificará el importe final del pedido.' },

        { Id: 'envio-empresa', Nombre: 'Empresa logistica', Tipo: 'text', Ayuda: 'Intentaremos detectar el transporte. Para mayor exactitud podes modificar estas celdas con el codigo interno del transporte. Ej C05 = CORREO ARGENTINO.' },
        { Id: 'envio-tracking', Nombre: 'Número de tracking', Tipo: 'text' },

        {
            Id: 'envio-tipo', Nombre: 'Modo de envío', Tipo: 'text',
            Validar: async ( x: string ) =>
            {
                let e = Envios.Tipos.toTipo( x );
                return e.Id != e.Descripcion;
            },
            MensajeError: `<p class="t-x-normal fw-500">No se pudieron validar las celdas. Compruebe que los valores de las mismas esten dentro de:<p>
                           <ul>
                           ${Envios.Tipos.Options.map( x => '<li class="t-xx-normal">' + x.Id + '</li>' ).join( ' ' )}
                           </ul>
                            `
        },
        { Id: 'envio-direcion-calle', Nombre: 'Dirección de envío - Calle', Tipo: 'text' },
        { Id: 'envio-direcion-numero', Nombre: 'Dirección de envío - Número', Tipo: 'text' },
        { Id: 'envio-direcion-piso', Nombre: 'Dirección de envío - Piso', Tipo: 'text' },
        { Id: 'envio-direcion-departamento', Nombre: 'Dirección de envío - Departamento', Tipo: 'text' },
        //        { Id: 'envio-direcion-calle-completa', Nombre: 'Dirección de envío - Calle y numero', Tipo: 'text' },
        { Id: 'envio-direcion-localidad', Nombre: 'Dirección de envío - Localidad', Tipo: 'text' },
        { Id: 'envio-direcion-provincia', Nombre: 'Dirección de envío - Provincia', Tipo: 'text' },
        { Id: 'envio-direcion-codigo-postal', Nombre: 'Dirección de envío - Codigo Postal', Tipo: 'text' },
        { Id: 'envio-direcion-entre', Nombre: 'Dirección de envío - Entra calles', Tipo: 'text' },
        { Id: 'envio-direcion-comentario', Nombre: 'Dirección de envío - Comentario', Tipo: 'text' },
        { Id: 'envio-direcion-recibe', Nombre: 'Recibe el pedido', Tipo: 'text' },
        { Id: 'envio-direcion-documento', Nombre: 'Documento de quien recibe', Tipo: 'text' },
        { Id: 'envio-direcion-telefono', Nombre: 'Telefono de quien recibe', Tipo: 'text' },


        { Opcion: 'titulo', Nombre: 'Pedido' },
        { Id: 'pedido-fecha', Nombre: 'Fecha del pedido', Tipo: 'text', Ayuda: 'Fecha de creación  del pedido. Si no podemos detectarla se utilzará la fecha de hoy.' },
        { Id: 'pedido-id-externa', Nombre: 'Nº de Carrito - Id Externa', Tipo: 'text', Ayuda: 'Número que identifica el pedido en su plataforma' },

        { Id: 'articulo-id-externa', Nombre: 'Id de la publicación', Tipo: 'text', Ayuda: 'Id de la publicación o SKU de la plataforma' },
        {
            Id: 'articulo-id', Nombre: 'Código del artículo', Tipo: 'text', Ayuda: 'Codigo del artículo. Si no incluye la barra, lo detectaremos automaticamente.',

            Validar: async ( x: string ) =>
            {
                let e = await Articulo.Comprobar( x );
                return e;
            },
            MensajeError: `Alguna de estas celdas no contienen un artículo existente`
        },


        { Id: 'articulo-cantidad', Nombre: 'Cantidad', Tipo: 'number' },
        { Id: 'articulo-importe-iva', Nombre: 'Importe unitario del artículo (con IVA)', Tipo: 'number' },
        { Id: 'articulo-importe-sin-iva', Nombre: 'Importe unitario del artículo (sin IVA)', Tipo: 'number' },

        { Opcion: 'titulo', Nombre: 'Pago' },
        { Id: 'pago-id-externa', Nombre: 'Identificador numerico del pago', Tipo: 'text' },
        { Id: 'pago-referencia', Nombre: 'Referencia del pago', Tipo: 'text' },
        { Id: 'pago-medio', Nombre: 'Medio de pago', Tipo: 'text' },
        { Id: 'pago-importe-pagado', Nombre: 'Importe pagado (con IVA)', Tipo: 'number' },
        { Id: 'pago-importe-financiacion', Nombre: 'Importe costo financiación (con IVA)', Tipo: 'number' },
        { Id: 'pago-importe-comision', Nombre: 'Importe comisión de plataforma (con IVA)', Tipo: 'number' },
        { Id: 'pago-cuotas', Nombre: 'Cuotas', Tipo: 'number' },
        { Id: 'pago-importe-cuotas', Nombre: 'Importe cuota', Tipo: 'number' },

    ];


    public Columnas: Record<number, string> = {};
    public HayErrores()
    {
        for ( let col of Object.keys( this.Columnas ) )
        {
            if ( this.Columnas[parseInt( col )] == 'error' )
                return true;
        }
        return false;
    }
    public Archivo: { encabezados: string[]; columnas: Array<string[]>; } = { encabezados: [], columnas: [] };


    public async ComprobarArchivo( archivo: any )
    {
        this.Vista.Estado = 'cargando';
        this.LimpiarPreset();
        if ( archivo )
        {
            let data = await Pedido.ComprobarImportarExcel( archivo );
            if ( data )
            {
                this.Archivo = data;
                this.Vista.Estado = 'archivo-cargado';
                return true;
            } else
            {
                Utiles.Notificaciones.Error( 'Error al leer el archivo!' );
            }
        }

        this.Vista.Estado = 'iniciado';
    }

    Iniciar()
    {
        this.Vista.Estado = 'iniciado';
        //this.Vista.Estado = 'pedidos';
    }


    public Vista: Vista = new Vista();
    private _onRecargar = new SignalDispatcher();
    public get onRecargar() { return this._onRecargar.asEvent(); }

    public Tipo: Pedidos.Tipos = null;
    ObtenerDatos()
    {
        let Data: Record<string, string>[] = [];
        for ( let data of this.Archivo.columnas )
        {
            let dat: Record<string, string> = {};
            for ( var i = 0; i < data.length; i++ )
            {
                if ( this.Preset[i] )
                {
                    dat[this.Preset[i]] = data[i];
                }
            }
            Data.push( dat );
        }
        return Data;
    }
    Ejecutar()
    {
        this._onEjecutar.dispatch();
    }
    private _onEjecutar = new SignalDispatcher();
    public get onEjecutar() { return this._onEjecutar.asEvent(); }
}

export class Vista extends VistaBase
{


}

//const Controlador = new ControladorSeccion();
//export { Controlador };

